export default __webpack_public_path__ + "static/media/designer-dashboard-blurred.b55b7a4b.png";